import { lazy, memo, Suspense } from 'react'

import type { editor } from 'monaco-editor/esm/vs/editor/editor.api'

import { HtmlEditorProps } from '@shared/components/Editor/HtmlEditor'
import { JsonEditorProps } from '@shared/components/Editor/JsonEditor'
import { LoadingIndicator } from '@shared/layouts'

export type EditorInstance = editor.IStandaloneCodeEditor

const JsonEditor = lazy(() => import('@shared/components/Editor/JsonEditor'))
const HtmlEditor = lazy(() => import('@shared/components/Editor/HtmlEditor'))

type EditorProps<V> =
  | ({
      language?: 'json'
    } & JsonEditorProps<V>)
  | ({
      language: 'html'
    } & HtmlEditorProps)

const SuspenseWrapperRaw = <V,>(props: EditorProps<V>) => {
  if (props.language === 'html') {
    return (
      <Suspense fallback={<LoadingIndicator />}>
        <HtmlEditor {...props} />
      </Suspense>
    )
  }

  return (
    <Suspense fallback={<LoadingIndicator />}>
      <JsonEditor {...props} />
    </Suspense>
  )
}

export const Editor = memo(SuspenseWrapperRaw) as typeof SuspenseWrapperRaw
